var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 45,
    viewBox: "0 0 93 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.1875 13.644L3.99607 44.0719L0.459758 33.7061C-0.346315 31.3433 0.915659 28.7744 3.27846 27.9683L83.9134 0.459552C86.2762 -0.346521 88.8451 0.915454 89.6512 3.27825L93.1875 13.644Z",
    fill: "url(#paint0_linear_1617_78832)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1617_78832",
    x1: 4.1039,
    y1: 40.0386,
    x2: 99.134,
    y2: -0.467028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FCA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnTop);
export default __webpack_public_path__ + "static/media/earn-top.1ec0cbe9e1eaa38a4f635074891f2805.svg";
export { ForwardRef as ReactComponent };